import moment from 'moment';

export function formatLocaleDate(value, locale = 'en') {
  return moment(value).locale(locale).format('LL');
}

export function formatLocaleDatetime(value, locale = 'en') {
  return moment(value).locale(locale).format('LLL');
}
